module.exports = __webpack_public_path__ + "static/media/java_logo.7531ac85.png";